import Cookies from 'js-cookie';
import { DEFAULT_REDIRECT_URL } from 'dashboard/constants/globals';
import { frontendURL } from 'dashboard/helper/URLHelper';

export const hasAuthCookie = () => {
  return !!Cookies.get('cw_d_session_info');
};

const getSSOAccountPath = ({ ssoAccountId, user }) => {
  const { accounts = [], account_id = null } = user || {};
  const ssoAccount = accounts.find(
    account => account.id === Number(ssoAccountId)
  );
  let accountPath = '';
  if (ssoAccount) {
    accountPath = `accounts/${ssoAccountId}`;
  } else if (accounts.length) {
    // If the account id is not found, redirect to the first account
    const accountId = account_id || accounts[0].id;
    accountPath = `accounts/${accountId}`;
  }
  return accountPath;
};

export const getLoginRedirectURL = async ({
  ssoAccountId,
  ssoConversationId,
  redirectTo,
  user,
}) => {
  if (redirectTo) {
    try {
      const decoded = decodeURIComponent(redirectTo);
      const url = new URL(decoded, window.location.origin);
      const isSafeRedirect =
        url.origin === window.location.origin ||
        url.hostname === 'localhost' || url.hostname.endsWith('.dropechat.com');
      if (isSafeRedirect) {
        return decoded;
      }
    } catch (e) {
      // Invalid redirect URL, fall through to default behaviour below.
    }
  }

  const accountPath = getSSOAccountPath({ ssoAccountId, user });
  if (accountPath) {
    const pendingCheckoutUrl = await getPendingCheckoutURL(user);
    if (pendingCheckoutUrl) {
      return pendingCheckoutUrl;
    }
    if (ssoConversationId) {
      return frontendURL(`${accountPath}/conversations/${ssoConversationId}`);
    }
    return frontendURL(`${accountPath}/dashboard`);
  }
  return DEFAULT_REDIRECT_URL;
};

const getPendingCheckoutURL = async user => {
  const accountId = user?.account_id;
  if (!accountId) return null;

  try {
    const response = await fetch(`/api/v1/accounts/${accountId}/subscription`, {
      headers: { api_access_token: user.access_token || '' },
    });
    if (!response.ok) return null;
    const data = await response.json();
    if (data.sub_status === 'pending_payment' && data.plan_name) {
      return `${window.dropechatConfig.billingUrl}/billing/checkout/${data.plan_name}`;
    }
  } catch (e) {
    // Network/parse error, fall through to normal redirect behaviour.
  }
  return null;
};
